module.exports = __webpack_public_path__ + "media/images/badges/kinrgy-badge-75a2f54ba46283efd1d333e8e29d1a68.png";